import { alpha } from '@mui/system/colorManipulator';

export { neutral, blue, green, indigo, purple, success, info, warning, error } from '../shared/colors';

const withAlphas = (color) => {
  return {
    ...color,
    alpha4: alpha(color.main, 0.04),
    alpha8: alpha(color.main, 0.08),
    alpha12: alpha(color.main, 0.12),
    alpha30: alpha(color.main, 0.3),
    alpha50: alpha(color.main, 0.5),
  };
};

export const orange = withAlphas({
  lightest: '#E17000',
  light: '#E17000',
  main: '#E17000',
  dark: '#E17000',
  darkest: '#E17000',
  contrastText: '#FFFFFF',
});

